export default __webpack_public_path__ + "static/media/General news logo_0.e90d8de6.png";